import { MapToolbar as View } from 'ui-components'
import { useMapNavStore } from '~map-preview/states/mapNav'
import { Visualization } from './Visualization'
import { ZoomControl } from './ZoomControl'

export const MapToolbar = () => {
  const { infoGraphicOpen, drawerOpen } = useMapNavStore()
  if (infoGraphicOpen && drawerOpen) return null
  return (
    <View
      slots={{
        Visualization,
        ZoomControl
      }}
    />
  )
}
